export const pickElementById = (element) => document.getElementById(element)

export const pickElement = (element) => document.querySelector(element)

export const pickElementAll = (element) => document.querySelectorAll(element)

export const createElement = (element) => document.createElement(element)

export const objectIsVoid = (object = {}) => Object.keys(object).length === 0
